var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _rect7, _rect8, _rect9, _rect0, _path3, _path4, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipmentSuperior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 110 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.0801,
    y: 1.39209,
    width: 14.9614,
    height: 62.7358,
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.3261,
    height: 13.2612,
    transform: "matrix(-1 0 0 1 86.3672 25.5356)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 14.5363,
    height: 20.3169,
    transform: "matrix(-1 0 0 1 88.5781 8.87256)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 19.1268,
    height: 9.52088,
    transform: "matrix(-1 0 0 1 93.1689 35.7354)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.39568,
    height: 13.2612,
    transform: "matrix(-1 0 0 1 81.4375 25.5356)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 106.6,
    y: 64.1279,
    width: 32.558,
    height: 18.8717,
    transform: "rotate(-180 106.6 64.1279)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 64.1279H77.442",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5576 64.1279H-0.000396527",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 33.7481,
    height: 7.05565,
    transform: "matrix(-1 0 0 1 59.0801 8.87256)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 6.54561,
    height: 5.18548,
    transform: "matrix(-1 0 0 1 84.582 12.6133)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 59.0801,
    y: 30.5498,
    width: 28.9027,
    height: 14.6214,
    transform: "rotate(-180 59.0801 30.5498)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 59.0801,
    y: 64.1279,
    width: 24.291,
    height: 33.5781,
    transform: "rotate(-180 59.0801 64.1279)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3749 45.2574H52.4507V26.5557H3.91119V42.961H3.91113V64.1279H44.3749V45.2574Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4507 45.2574V46.0074H53.2007V45.2574H52.4507ZM44.3749 45.2574V44.5074H43.6249V45.2574H44.3749ZM52.4507 26.5557H53.2007V25.8057H52.4507V26.5557ZM3.91119 26.5557V25.8057H3.16119V26.5557H3.91119ZM3.91119 42.961V43.711H4.66119V42.961H3.91119ZM3.91113 42.961V42.211H3.16113V42.961H3.91113ZM3.91113 64.1279H3.16113V64.8779H3.91113V64.1279ZM44.3749 64.1279V64.8779H45.1249V64.1279H44.3749ZM52.4507 44.5074H44.3749V46.0074H52.4507V44.5074ZM51.7007 26.5557V45.2574H53.2007V26.5557H51.7007ZM3.91119 27.3057H52.4507V25.8057H3.91119V27.3057ZM4.66119 42.961V26.5557H3.16119V42.961H4.66119ZM3.91113 43.711H3.91119V42.211H3.91113V43.711ZM4.66113 64.1279V42.961H3.16113V64.1279H4.66113ZM44.3749 63.3779H3.91113V64.8779H44.3749V63.3779ZM43.6249 45.2574V64.1279H45.1249V45.2574H43.6249Z",
    fill: "#808080"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 44.374,
    y: 64.1279,
    width: 19.1693,
    height: 18.8717,
    transform: "rotate(-180 44.374 64.1279)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7891,
    y: 64.1279,
    width: 9.58464,
    height: 18.8717,
    transform: "rotate(-180 34.7891 64.1279)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 44.374,
    y: 64.1279,
    width: 9.58464,
    height: 18.8717,
    transform: "rotate(-180 44.374 64.1279)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9688,
    y: 40.3267,
    width: 33.5781,
    height: 6.88564,
    transform: "rotate(-180 44.9688 40.3267)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4414,
    y: 40.3267,
    width: 11.051,
    height: 6.88564,
    transform: "rotate(-180 22.4414 40.3267)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 53.2998,
    y: 23.5806,
    width: 17.3416,
    height: 3.82535,
    transform: "rotate(-180 53.2998 23.5806)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1611,
    y: 5.13232,
    width: 6.80063,
    height: 6.80063,
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1611,
    y: 15.3345,
    width: 6.80063,
    height: 6.80063,
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1611,
    y: 25.5356,
    width: 6.80063,
    height: 6.80063,
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1611,
    y: 35.7354,
    width: 6.80063,
    height: 6.80063,
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1611,
    y: 45.936,
    width: 6.80063,
    height: 6.80063,
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentSuperior);
export default __webpack_public_path__ + "static/media/equipment_superior.24e844bac48efd5f74374ec7ed164e94.svg";
export { ForwardRef as ReactComponent };